module.exports = __webpack_public_path__ + "static/media/icn_tax_made_simple.fe1519d8.svg";